module.exports = __webpack_public_path__ + "static/media/prestamos.6eb264bb.svg";